/**
 * Whether this tab has anywhere to go back to — the single signal behind every
 * "Back" / "Cancel" affordance in the deep-link resolution surface, so they
 * stay consistent. `window.history.length > 1` is true whenever the tab has a
 * prior entry: after an in-app click (a clean soft back) AND after a same-tab
 * address-bar paste (a full-reload back to the prior page). Only a genuinely
 * fresh tab (length 1) has nothing to return to, so it falls back to Home.
 *
 * Deliberately NOT React Router's `state.idx`: that resets to 0 on any full
 * document load (address-bar paste, hard refresh), which would hide a valid
 * Back for a user who simply pasted a URL over the page they were on.
 */
export function canNavigateBack(): boolean {
  return window.history.length > 1;
}
